// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37a8d1e2","980":"25a6588a"}[chunkId] + ".chunk.js";
};